<div id="userCreateFileModal" class="modal " tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{'ImportUsers'|localize}}  {{ createUserListDemo.length>0? '- '+('ExampleFileStruct'|localize):''}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <table class="table">
                    <thead>
                    <tr style="text-align: center">
                        <th scope="col">#</th>
                        <th scope="col">Ad</th>
                        <th scope="col">Soyad</th>
                        <th scope="col">Mail</th>
                        <th scope="col">#</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of  createUserListDemo && createUserListDemo.length>0? createUserListDemo:createUserList; let i=index">
                            <td>{{i+1}}</td>
                            <td>
                                <input [disabled]="createUserListDemo.length>0" type="text" class="form-control" [(ngModel)]="user.first_name">
                            </td>
                            <td>
                                <input [disabled]="createUserListDemo.length>0" type="text" class="form-control" [(ngModel)]="user.last_name">
                            </td>
                            <td>
                                <input [disabled]="createUserListDemo.length>0" type="email" class="form-control" [(ngModel)]="user.email">
                            </td>
                            <td style="text-align: center!important;">

                                <i-tabler *ngIf="user.createFailMessage" [title]="'Retry'|localize" (click)="importSingleUser(i)" name="square-rounded-arrow-right" style="color:green" class="float-end" ></i-tabler>
                                <i-tabler *ngIf="user.createFailMessage" [title]="user.createFailMessage|localize" name="x" style="color:red" class="float-end" ></i-tabler>
                                <i-tabler *ngIf="user.id" [title]="user.createFailMessage" name="check" style="color:green" class="float-end" ></i-tabler>
                                <i-tabler *ngIf="!user.id"  [title]="'Delete'|localize"  (click)="deleteUserOnAddFile(i,createUserListDemo.length>0)" name="trash-x" class="float-end  {{createUserListDemo.length>0 || user.id?'disabled':''}}" ></i-tabler>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button [disabled]="createUserListDemo.length>0 || createUserList.length==0 || saveRequestSended==true"
                        (click)="saveImportUserList()"
                        type="button" class="btn btn-primary">{{'Save'|localize}}</button>
            </div>
        </div>
    </div>
</div>

<div class="row w-100">
    <div *ngIf="window.globalActiveUser && window.globalActiveUser.organisationAccount && window.globalActiveUser.organisationAccount.type==EnumOrganisationType.COMPANY">

        <i-tabler name="info-circle" (click)="openCreateUserFileDemo()" class="ms-1 float-end" ></i-tabler>
        <label  for="fileUploadForUserInput" class="custom-upload-btn float-end">
            {{'ImportUsers'|localize}}
        </label>
        <input type="file" id="fileUploadForUserInput" (change)="onUserAddFileChange($event)" accept=".xlsx, .csv, .ods" hidden/>
    </div>
    <div class="table-responsive-sm w-100">
        <mat-table *ngIf="userMap && userMap.data && userMap.data.length>0" #table [dataSource]="userMap">
            <ng-container matColumnDef="first_name">
                <mat-header-cell *matHeaderCellDef >
                    {{ "first_name" | localize }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{ user.first_name }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="last_name">
                <mat-header-cell *matHeaderCellDef >
                    {{ "last_name" | localize }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{ user.last_name }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef >
                    {{ "email" | localize }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{ user.email }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email_verified">
                <mat-header-cell *matHeaderCellDef >
                    {{ "email_verified" | localize }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{ user.email_verified.toString()|localize }}
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="enabled">
                <mat-header-cell *matHeaderCellDef >
                    {{ "enabled" | localize }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{ user.enabled.toString()|localize }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="roles">
                <mat-header-cell *matHeaderCellDef >
                    {{ "roles" | localize }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{ user.roles }}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <tr class="mat-row" *matNoDataRow style="justify-content: center !important; display: flex;">
<!--                <td colspan="5" *ngIf="isDataLoading" class="d-flex flex-col align-items-center justify-content-center">-->
<!--                    <mat-spinner diameter="40"></mat-spinner>-->
<!--                    <p>{{"RoleManagement.CodesLoading" | localize}}</p>-->
<!--                </td>-->
<!--                <td *ngIf="!isDataLoading" class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center;">-->
<!--                    {{"RoleManagement.NoCode" | localize}}-->
<!--                </td>-->
            </tr>
        </mat-table>
        <mat-paginator *ngIf="userMap?.data?.length" [pageSize]="10" [length]="totalCount"
                       [pageIndex]="pageNumber" [pageSizeOptions]="[10, 20, 50]" (page)="onPageChange($event)" >
        </mat-paginator>
    </div>

</div>
